import { useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import AdvisorConversation from './AdvisorConversation'
import { getCourse } from '../../knowledge'
import { trackAdvisorOpened } from '../../services/websiteTracker'

export default function AdvisorShell() {
  const [searchParams] = useSearchParams()
  const courseCode = searchParams.get('course') || searchParams.get('c') || null
  const targetCourse = courseCode ? getCourse(courseCode) : null

  useEffect(() => {
    trackAdvisorOpened()
  }, [])

  return (
    <div className="cinema-page advisor-page h-[100svh] max-h-[100svh] flex flex-col overflow-hidden selection:bg-cinema-glow/30 selection:text-white">
      <div className="cinema-grain" aria-hidden="true" />
      <div className="cinema-glow-orb w-[420px] h-[420px] -top-36 -right-20 opacity-35" />

      <header className="relative z-50 shrink-0 border-b border-white/5">
        <div className="max-w-3xl mx-auto px-5 sm:px-8 py-4 sm:py-5">
          <Link
            to={targetCourse ? "/programs" : "/explore"}
            className="advisor-back"
          >
            {targetCourse ? "← Back to Programs & Courses" : "← Back to Explore SMA"}
          </Link>

          <div className="mt-4 flex items-center justify-between gap-3">
            <div className="min-w-0">
              <h1 className="font-display text-lg sm:text-xl text-white tracking-tight">
                {targetCourse ? (
                  <span>
                    Admissions Advisor &bull; <span className="text-cinema-gold">{targetCourse.title}</span>
                  </span>
                ) : (
                  'SMA Admissions Advisor'
                )}
              </h1>
              <p className="mt-1.5 flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-cinema-gold font-medium">
                <span className="relative flex h-2 w-2 shrink-0" aria-hidden="true">
                  <span className="advisor-pulse absolute inline-flex h-full w-full rounded-full bg-cinema-gold opacity-60" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-cinema-gold" />
                </span>
                {targetCourse ? `Course Inquiry (${targetCourse.code})` : 'Online'}
              </p>
            </div>
          </div>
        </div>
      </header>

      <AdvisorConversation initialCourseCode={courseCode} />
    </div>
  )
}
